import { observable, action, makeObservable } from 'mobx';

class AuthorizationStore {
  constructor() {
    makeObservable(this);
  }

  @observable isLoggedIn = true;

  @action setIsLoggedIn(value: boolean) {
    this.isLoggedIn = value;
  }
}

export const auth = new AuthorizationStore();
